<template>
  <a class="instagram_to_content" v-bind:href="permalink" target="_blank">
    <div class="instagram-content-area" v-on:mouseover="instagramMouseover" v-on:mouseleave="instagramMouseleave">
        <div class="instagram-text-area" v-show="showInstagramTwxt">
            <span class="instagram-text-date">{{ timestamp }}</span><br>
            <span class="instagram-date-border"></span>
            <span class="instagram-text-caption">{{ caption }}</span>
        </div>
        <img  class="instagram-thumbnail" v-bind:src="media_url">
    </div>
  </a>
</template>

<script>
export default {
  props: {
    timestamp: String,
    permalink: String,
    caption: String,
    media_url: String,
    isDisplay: Boolean,
  },
  data() {
    return{
      showInstagramTwxt: false
    }
  },
  methods: {
    /**
     * PCマウス操作アクション
     * 作品フォーカス時
     */
    instagramMouseover: function() {
      this.showInstagramTwxt = true;
    },
    /**
     * PCマウス操作アクション
     * 作品フォーカス外
     */
    instagramMouseleave: function() {
      this.showInstagramTwxt = false;

    }
  }
}
</script>

<style lang="scss" scoped>
.instagram-text-area {
  position: absolute;
  height: 41vw;
  top:0;
  padding-left: 5%;
  padding-right: 5%;
  z-index: 10;
  background: rgba(0,0,0,0.5);
  color: #ffffff;
}
.instagram-date-border {
  height: 1px;
  width: 35px;
  background-color: #ffffff;
  display: block;
  margin: 5px 0 7px 0;
}
.instagram-text-caption {
  // キャプションが2行以上の場合省略
  overflow: hidden;
  height: auto;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-height: 25px;
}
.instagram-content-area {
  position: relative;
  width: 41vw;
  height: 41vw;
  overflow: hidden;
}
.instagram-thumbnail {
  position: absolute;
  width: 100%;
  top:0;
  left: 0;
}
// ipad以下
@media screen and (max-width: 1024px) {

}
// PC
@media screen and (min-width: 768px) {
.instagram-content-area {
  width: 9vw;
  height: 9vw;
}
.instagram-text-area {
  height: 9vw;
  padding-left: 5%;
  z-index: 10;
  background: rgba(0,0,0,0.5);
  color: #ffffff;
}  
}
</style>